import React from 'react';
import Blog from './blogs/blog';
import Blog05 from './blogs/blogzerofive';

function Bloglist() {
	return (
		<div className='bloglistpage'>
			<div className='bl-note'>(website is a work in progress)</div>
			<div className='bl-title'>Total blogs: 2</div>
			<div className='bl-body'>
				<Blog05 />
				<Blog />
			</div>
		</div>
	);
}

export default Bloglist;
